import { WarningCircleIcon as PhosphorWarningCircleIcon } from "@phosphor-icons/react/dist/ssr/WarningCircle";

import { createAppIcon } from "@/components/createAppIcon";

export const ErrorIcon = /* @__PURE__ */ createAppIcon(PhosphorWarningCircleIcon);
